var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlacementAssistance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_59",
    "data-name": "Group 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.271,
    height: 84.95,
    viewBox: "0 0 97.271 84.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 97.271,
    height: 84.95,
    fill: "#e68242"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M77.129,226.988V207.919a42.643,42.643,0,0,1,12.372.237c1.492.244,3.091.859,4.547.99,5.1.456,10.909-.46,16-.005a3.4,3.4,0,0,1,.2,6.782c-5.094.478-11.2-.589-16.211-.012-2,.23-2.083,2.776.228,3.063A105.351,105.351,0,0,0,109.43,219a14.7,14.7,0,0,0,3.072-.824c10.949-3.393,19.851-9.894,29.824-15.285,3.806-.981,5.92,3.41,2.859,5.73-9.725,5.919-19.1,15-29.576,19.429-12.7,5.368-25.488-.537-38.481-1.061",
    transform: "translate(-55.562 -146.055)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M142.571,135.445v17.121c0,.405-1.177,1.347-1.634,1.441l-36,.1c-.617.085-2.148-1.032-2.148-1.543V135.445l16.536,8.787a8.545,8.545,0,0,0,6.568.067Z",
    transform: "translate(-74.049 -97.571)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M102.7,109.925c0-2.16-.77-4.855,2.1-5.294H140.29c2.8.338,2.3,3.426,1.946,5.441-4.948,2.4-9.651,5.316-14.556,7.793-2.3,1.164-4.609,2.758-7.257,1.507Z",
    transform: "translate(-73.916 -75.373)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M42.075,237.705a3.03,3.03,0,0,1-1.275.468,40.919,40.919,0,0,1-6.16,0,1.81,1.81,0,0,1-1.491-.97L33.1,214.065l.771-1.074c1.58.2,6.9-.489,7.966.149a1.317,1.317,0,0,1,.457.569c-.278,2.789.609,23.125-.215,24",
    transform: "translate(-23.841 -153.339)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M140.7,65.266a83.666,83.666,0,0,1,12.672-.057c4.013.358,4.628,4.535,4.105,7.813a4.648,4.648,0,0,1-2.9,0l-.133-3.968a1.582,1.582,0,0,0-1.016-.83c-1.283-.389-9.652-.3-11.354-.144-3.143.294-1.5,2.733-2.029,4.942l-2.794.1c-.73-2.818-.07-7.27,3.445-7.858",
    transform: "translate(-98.686 -46.822)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M85.63,22.578a1.575,1.575,0,0,1,1.492.684,41.191,41.191,0,0,1,2.371,4.207,1.5,1.5,0,0,1-2.583,1.336c-.211-.226-2.236-3.7-2.342-4.013a1.574,1.574,0,0,1,1.062-2.214",
    transform: "translate(-60.836 -16.249)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M248.574,22.57a1.547,1.547,0,0,1,1.644,2.072c-.065.237-2.215,3.949-2.406,4.155a1.506,1.506,0,0,1-2.632-.877c-.061-.737,2.509-5.189,3.394-5.35",
    transform: "translate(-176.62 -16.241)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M22.986,86.97a1.541,1.541,0,0,1,1.2-2.5c.744.084,4.862,2.456,5.06,3.118.387,1.293-.6,2.111-1.859,1.861a42.965,42.965,0,0,1-4.4-2.476",
    transform: "translate(-16.327 -60.841)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M307.686,86.97a42.961,42.961,0,0,1-4.4,2.476c-1.261.25-2.246-.568-1.859-1.861.2-.662,4.315-3.035,5.06-3.118a1.541,1.541,0,0,1,1.2,2.5",
    transform: "translate(-217.079 -60.841)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M169.929,0c1.053-.056,1.436.763,1.516,1.672a29.579,29.579,0,0,1-.052,4.683A1.483,1.483,0,0,1,168.554,6a29.106,29.106,0,0,1,.055-4.887A1.468,1.468,0,0,1,169.929,0",
    transform: "translate(-121.367 0)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M.8,169.079a41.986,41.986,0,0,1,5.658,0c1.124.337,1.1,2.552-.587,2.819a26.1,26.1,0,0,1-4.661-.032c-1.438-.322-1.617-2.437-.41-2.784",
    transform: "translate(0 -121.73)",
    fill: "#e68242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M322.769,169.076a41.986,41.986,0,0,1,5.658,0c1.246.358,1.04,2.559-.583,2.816a26.1,26.1,0,0,1-4.661-.032c-1.5-.336-1.5-2.463-.414-2.788",
    transform: "translate(-231.961 -121.73)",
    fill: "#e68242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacementAssistance);
export default __webpack_public_path__ + "static/media/placement_assistance.39996c2ab1b23a4df7e420210b6ca13e.svg";
export { ForwardRef as ReactComponent };